<template>
    <div v-if="gender" class="gender">
      <hp5-spacing-vertical sm="xs"></hp5-spacing-vertical>
      <hp5-semantic size-selection="xs">
        <span><hp5-heading size-selection="xxs" tag-selection="h4">Gender: </hp5-heading></span>
        <span class="align">{{ gender }}</span></hp5-semantic
      >
    </div>
</template>

<script setup>

    const props = defineProps({
        result: Object
    })

    const gender = computed(() => {
      if (!props.result.gender) return ''
      
      return props.result.gender.toLowerCase() == 'male' || props.result.gender.toLowerCase() == 'female' ? props.result.gender : 'Non-binary or chose not to say'
    })
    
</script>

<style lang="scss" scoped>
@use '../../../../assets/scss/breakpoints' as *;
  
  .gender {
    display: flex;
  
    span {
      float: left;
      margin-right: var(--spacing-xxs);
    }
    @include small-up {
      .align {
        margin-top: 1px;
      }
    }
  }
</style>